arrayCollectionsId.forEach((id) => {
  if (id !== selectedFeaturedCollection) {
    document.getElementById("slider-featured-collection-" + id).classList.add("featured-collection-inactive");
  }
});

$( document ).ready(function() {
  $('.blocCategProduct h2').filter(function() {
    return $(this).text().trim().includes('ALL GEAR');
}).addClass('textUnderlineCateg');

  
  arrayCollectionsId.forEach((id) => {
    $("#button-featured-collection-" + id).on( "click", function() {
      $('.blocCategProduct').find('.textUnderlineCateg').removeClass('textUnderlineCateg');
      changedSelectedFeaturedCollection(id);
      $(this).addClass('textUnderlineCateg');
    });
  });
});

function changedSelectedFeaturedCollection(idElement) {
  arrayCollectionsId.forEach((id) => {
    if (id !== idElement) {
      document.getElementById("slider-featured-collection-" + id).classList.add("featured-collection-inactive");
    } else {
      document.getElementById("slider-featured-collection-" + idElement).classList.remove("featured-collection-inactive");
    }
  });
}